import { Color } from '@/common/colors/colors';

type Props = {
	title: string;
	onClick?: () => void;
	style?: React.CSSProperties;
	inverted?: boolean;
};

function GradientButton({ title, onClick, inverted, style }: Props) {
	return (
		<div
			style={{
				display: 'inline-flex',
				justifyContent: 'center',
				alignItems: 'center',
				borderRadius: 100,
				background: !inverted
					? 'linear-gradient(200deg, #4322c6 28.95%, #48068a 74.94%)'
					: 'white',
				color: !inverted ? '#fff' : Color.DarkPurple,
				textAlign: 'center',
				fontFamily: 'Work Sans',
				fontSize: 18,
				fontStyle: 'normal',
				fontWeight: 700,
				lineHeight: 'normal',
				letterSpacing: 0.72,
				textTransform: 'uppercase',
				border: !inverted ? 'none' : '1px solid #29185E',
				cursor: 'pointer',
				...style,
			}}
			onClick={onClick}
		>
			{title}
		</div>
	);
}

export default GradientButton;
